module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAPFBMVEUAAAAAo90BAQABo9wetTofqcUftTohGwM5uDZmto1ntoxpVwl5wCu6xUq8nBDCyh/vzyDwxxXxyBXx0BjyW1O/AAAAYUlEQVR42n3NyQqAMBRD0bw6VK1T9f//VUE0LkKyvRyCVm3Yakm4p3I/n2vGM0OZNU0FhuZ1h6HH0sHQsQkYGhEwlFlRZkGZFWUWlFlSZkmZJWX+0+mlzB+tpJx85eQrdwHaWAmH+UyVNAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/tz.png
// module id = 943
// module chunks = 0